import React from 'react';
import styled from 'styled-components';

const ContainerWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

function Container({ children }) {
  return <ContainerWrapper>{children}</ContainerWrapper>;
}

export default Container;